// TriggerFactory.ts
import { TimeTrigger } from "./TimeTrigger";
import { ElementOnScreenTrigger } from "./ElementOnScreenTrigger";
import { HoverTrigger } from "./HoverTrigger";
import { PublicEventTrigger } from "./PublicEventTrigger";
import { ScrollDepthTrigger } from "./ScrollDepthTrigger";
export class TriggerFactory {
    static create(type, instance, action) {
        switch (type) {
            case "time":
                return new TimeTrigger(instance, action);
            case "elementonscreen":
                return new ElementOnScreenTrigger(instance, action);
            case "hover":
                return new HoverTrigger(instance, action);
            case "publicevent":
                return new PublicEventTrigger(instance, action);
            case "scrolldepth":
                return new ScrollDepthTrigger(instance, action);
            default:
                return new TimeTrigger(instance, action);
        }
    }
}
